import {
  Box,
  Collapse,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
const FaqQuestionSectionWrapper = ({
  id,
  title,
  children,
  toggleSection,
  expanded,
}) => {
  return (
    <Box sx={{ width: '100%', my: 1 }}>
      <Box
        onClick={() => toggleSection(id)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          mb: 1,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.hover,
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{ flexGrow: 1 }}
          color={expanded ? 'text.primary' : 'text.secondary'}
        >
          {title}
        </Typography>
        <IconButton sx={{ borderRadius: 1 }}>
          {expanded ? <RemoveRoundedIcon /> : <AddRoundedIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Stack gap={1}>{children}</Stack>
      </Collapse>
      <Divider />
    </Box>
  );
};
export default FaqQuestionSectionWrapper;
